import React ,{useState} from 'react'
import { Link } from 'react-router-dom'

const Forget = () => {
  return (
    <div>Forget</div>
  )
}

export default Forget